import meter1 from "../../../assets/icons/1.svg";
import meter2 from "../../../assets/icons/2.svg";
import meter3 from "../../../assets/icons/3.svg";
import meter4 from "../../../assets/icons/4.svg";
import meter5 from "../../../assets/icons/5.svg";

export default function TrainingPower({ training_power }: { training_power: any }) {
  return (
    <>
      {training_power ? (
        training_power === "Ç" ? (
          <div className="d-flex flex-column align-items-center">
            <img
              src={meter5}
              width={20}
              alt="Çalışarak"
              data-tooltip-id="my-tooltip"
              data-tooltip-content="Hello world!"
            />
            <span className="fw-medium text-muted text-truncate" style={{ fontSize: "8px", fontWeight: "800" }}>
              ÇALIŞARAK
            </span>
          </div>
        ) : training_power === "HÇ" ? (
          <div className="d-flex flex-column align-items-center">
            <img src={meter4} width={20} alt="Hafif Çalışarak" />
            <span className="fw-medium text-muted text-truncate" style={{ fontSize: "8px", fontWeight: "800" }}>
              HAFİF ÇALIŞARAK
            </span>
          </div>
        ) : training_power === "HR" ? (
          <div className="d-flex flex-column align-items-center">
            <img src={meter3} width={20} alt="Hafif Rahat" />
            <span className="fw-medium text-muted text-truncate" style={{ fontSize: "8px", fontWeight: "800" }}>
              HAFİF RAHAT
            </span>
          </div>
        ) : training_power === "R" ? (
          <div className="d-flex flex-column align-items-center">
            <img src={meter2} width={20} alt="Rahat" />
            <span className="fw-medium text-muted text-truncate" style={{ fontSize: "8px", fontWeight: "800" }}>
              RAHAT
            </span>
          </div>
        ) : (
          <div className="d-flex flex-column align-items-center">
            <img src={meter1} width={20} alt="Çok Rahat" />
            <span className="fw-medium text-muted text-truncate" style={{ fontSize: "10px", fontWeight: "800" }}>
              ÇOK RAHAT
            </span>
          </div>
        )
      ) : (
        "-"
      )}
    </>
  );
}
